export default __webpack_public_path__ + "static/media/acc-inventure.ee55b5a5.png";